import { baseUrlName } from "../../lib/routes/baseUrl";

export const getAuthOptions = () => {
  switch (baseUrlName) {
    // case "":
    //   return { username: "system", password: "system" };
    default:
      return { username: "client", password: "secret" };
  }
};
